var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Czy na pewno chcesz usunąć tę zakładkę? ")])
}
var staticRenderFns = []

export { render, staticRenderFns }